module.exports = __webpack_public_path__ + "img/waybil_advantage.6f38f4f8.jpg";